import axios from "axios";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Layout } from "../Components/allcomponents";
import Accordion from "../Components/Layout/Accordion";
import FormContext from "../context/FormContext";

function Home() {
  const context = useContext(FormContext);
  const { Fields, FormInfo, setFormInfo } = context;
  const [image, setImage] = useState();
  const [loading, setLoading] = useState(false);

  const Navigate = useNavigate();
  //code

  const handleImage = async (e) => {
    const formData = new FormData();
    formData.append("image", e.target.files[0]);
    formData.append("tag", "imageUploadLogo");
    formData.append("Branch_id", localStorage.getItem("Branch_id"));

    try {
      const response = await fetch(
        "https://erpapi.eshiksa.net/imageUpload.php",
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();
      setFormInfo({ ...FormInfo, image: data.file_name });
      setImage(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleClick = async (e) => {
    e.preventDefault();
    setLoading(true);
    await axios
      .post("https://erpapi.eshiksa.net/uploadFormData.php", {
        Branch_id: localStorage.getItem("Branch_id"),
        dbname: "erp_eshiksa",
        tag: "formDataup",
        FormInfo,
        Fields,
      })
      .then((res) => {
        setLoading(false);
        if (res.data.success === 1) {
          Navigate("/Formlist");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  return (
    <React.Fragment>
      <Layout>
        {loading ? (
          <div
            style={{
              height: "100vh",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              className="spinner-border"
              style={{ color: "#88b0bc" }}
              role="status"
            >
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : (
          <div className="w-75 m-auto py-4">
            <form
              onSubmit={(e) => {
                handleClick(e);
              }}
            >
              <div className="row my-3">
                <div className="col-md-4">
                  <label className="my-1">Form Name</label>
                  <input
                    name="formName"
                    value={FormInfo.formName}
                    onChange={(e) => {
                      setFormInfo({
                        ...FormInfo,
                        [e.target.name]: e.target.value,
                      });
                    }}
                    required={true}
                    className="form-control"
                  />
                </div>
                <div className="col-md-4">
                  <label className="my-1">Payment Type</label>
                  <select
                    onChange={(e) => {
                      setFormInfo({
                        ...FormInfo,
                        [e.target.name]: e.target.value,
                      });
                    }}
                    name="paymentType"
                    required
                    value={FormInfo.paymentType}
                    className="form-control"
                  >
                    <option value="">Select</option>
                    <option value="fixed">Fixed</option>
                    <option value="variable">Variable</option>
                  </select>
                </div>

                {FormInfo["paymentType"] === "fixed" && (
                  <div className="col-md-4">
                    <label className="my-1">Fixed Amount</label>
                    <input
                      onChange={(e) => {
                        setFormInfo({
                          ...FormInfo,
                          [e.target.name]: e.target.value,
                        });
                      }}
                      name="fixedAmount"
                      required
                      value={FormInfo.fixedAmount}
                      type="number"
                      className="form-control"
                    />
                  </div>
                )}
                <div className="col-md-4">
                  <label className="my-1">Form Count</label>
                  <input
                    onChange={(e) => {
                      setFormInfo({
                        ...FormInfo,
                        [e.target.name]: e.target.value,
                      });
                    }}
                    name="count"
                    value={FormInfo.count}
                    className="form-control"
                  />
                </div>
                {image && (
                  <img
                    alt="logo"
                    className="my-3 "
                    style={{ width: 200 }}
                    src={image.filepath}
                  />
                )}
                <div className="col-md-6">
                  <label className="my-1">Logo</label>
                  <input
                    onChange={(e) => handleImage(e)}
                    name="image"
                    type="file"
                    className="form-control"
                  />
                </div>
                <div className="col-md-6">
                  <label className="my-1">Bank Partner</label>
                  <input
                    onChange={(e) => handleImage(e)}
                    name="bank_partner_logo"
                    type="file"
                    className="form-control"
                  />
                </div>
                <div className="col-md-12">
                  <label className="my-1">Terms & Condition</label>
                  <textarea
                    onChange={(e) =>
                      setFormInfo({
                        ...FormInfo,
                        [e.target.name]: e.target.value,
                      })
                    }
                    name="terms_condition"
                    className="form-control "
                    rows={5}
                  />
                </div>
                <div className="col-md-12">
                  <label className="my-1">Description</label>
                  <textarea
                    onChange={(e) =>
                      setFormInfo({
                        ...FormInfo,
                        [e.target.name]: e.target.value,
                      })
                    }
                    name="description"
                    className="form-control"
                    rows={5}
                  />
                </div>
              </div>
              <div className="accordion" id="accordionExample">
                {Fields.map((item, i) => {
                  return (
                    <Accordion
                      key={i}
                      id={item.id}
                      pointer={item.id}
                      labelName={item.labelName}
                      isRequired={item.isRequired}
                      formType={item.formType}
                      labelType={item.labelType}
                      mandatory={item.mandatory}
                      column_name={item.column_name}
                      moreoption={item.moreoption}
                      Component={item.Component}
                    />
                  );
                })}
              </div>
              <div className="col-md-12 text-end">
                <input
                  className="btn btn-sm btn-success my-3"
                  value="Create Form"
                  type="submit"
                ></input>
              </div>
            </form>
          </div>
        )}
      </Layout>
    </React.Fragment>
  );
}

export default Home;
